// extracted by mini-css-extract-plugin
module.exports = {"DiffViewer":"_1l2jWQw8OKpC-yVO5s_BfS"};